import Flex from '@Components/Bases/Flex';
import FormCheckbox from '@Components/Form/FormCheckBox';
import ChangeTypeModal from '@Components/Modal/ChangeTypeModal';
import {
  committeeOptions,
  CommitteeOptionsType,
} from '@Domains/Esg/EsgGreenhouse';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, InputLabel, styled, Typography } from '@mui/material';
import { useRef } from 'react';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import {
  IBoardResponsibilityFormValues,
  ISubcommitteeResponsibilityFormValues,
} from '../../EsgGreenhouseFormProvider/types';

const LabelStyles = styled(InputLabel)({
  width: '100%',
  minWidth: 200,
  maxWidth: 350,
  textAlign: 'right',
  whiteSpace: 'inherit',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  '&& .MuiInputLabel-asterisk': {
    whiteSpace: 'nowrap',
  },
});

const ClimateChangeStructureCheckbox = () => {
  const {
    setValue,
    unregister,
    watch,
    formState: { errors },
    trigger,
  } = useGreenhouseForm();

  const [isDialogOpen, { open: openDialog, close: closeDialog }] =
    useDisclosure();

  const typeChange = useRef<CommitteeOptionsType>('subcommitteeResponsibility');

  const climateChangeStructure = watch('climateChangeStructure');

  const committeeError = errors?.climateChangeStructure?.committee;

  const { isCompletedTh = false, isCompletedEn = false } =
    climateChangeStructure?.completedSection ?? {};

  const setInitialFormValues = (value: CommitteeOptionsType) => {
    switch (value) {
      case 'boardResponsibility':
        setValue(
          'climateChangeStructure.boardResponsibility',
          {} as IBoardResponsibilityFormValues
        );
        break;
      case 'subcommitteeResponsibility':
        setValue(
          'climateChangeStructure.subcommitteeResponsibility',
          {} as ISubcommitteeResponsibilityFormValues
        );
        break;
      default:
        break;
    }
  };

  const handleCommitteeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    option: CommitteeOptionsType
  ) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setInitialFormValues(option);
    } else {
      setValue(`climateChangeStructure.committee.${option}`, true);
      typeChange.current = option;
      openDialog();
    }

    trigger('climateChangeStructure.committee');
  };

  const handleConfirmCommitteeChange = () => {
    setValue(`climateChangeStructure.committee.${typeChange.current}`, false);
    unregister(`climateChangeStructure.${typeChange.current}`);
    closeDialog();
  };

  return (
    <>
      <Flex gap={3} my={2}>
        <LabelStyles required>
          กรุณาเลือกคณะกรรมการที่มีบทบาทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ
        </LabelStyles>
        <Box>
          {committeeOptions.map((option) => (
            <FormCheckbox
              key={option.value}
              name={`climateChangeStructure.committee.${option.value}`}
              label={option.label}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleCommitteeChange(event, option.value);
              }}
              inputProps={{ disabled: isCompletedTh || isCompletedEn }}
            />
          ))}
          {committeeError && (
            <Typography mt={2} variant={'caption'} color={'error.main'}>
              {committeeError.message}
            </Typography>
          )}
          {isDialogOpen && (
            <ChangeTypeModal
              opened={isDialogOpen}
              close={closeDialog}
              confirm={handleConfirmCommitteeChange}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};

export default ClimateChangeStructureCheckbox;
